var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("pila-documentos", { ref: "pilaDocumentos" }),
      _vm._v(" "),
      _c("FilePreview"),
      _vm._v(" "),
      !["login", "logout", "loginFlow"].includes(this.$route.name)
        ? _c("the-navbar")
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        on: { startLoading: _vm.startLoading, stopLoading: _vm.stopLoading },
      }),
      _vm._v(" "),
      _c("b-loading", {
        ref: "loader",
        attrs: { active: _vm.appLoading },
        on: {
          "update:active": function ($event) {
            _vm.appLoading = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }